import useIdBasedPagination from '~/hooks/useIdBasedPagination';
import type { PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem } from '~/server_shared/openapi/data-contracts';

const FETCH_IDS_URL = '/api/v1/contact_tfn_verification/pending/item_ids';
const FETCH_PAGE_DATA_URL = '/api/v1/contact_tfn_verification/pending/items_by_ids';
const DEFAULT_ROWS_PER_PAGE = 10;

interface UseTfnVerificationsPaginationProps {
  initialRowsPerPage?: number;
}

export const useTfnVerificationsPagination = ({
  initialRowsPerPage = DEFAULT_ROWS_PER_PAGE,
}: UseTfnVerificationsPaginationProps = {}) => {
  const fetchIdsParams = {};

  return useIdBasedPagination<
    string,
    null,
    PageDataResponseTfnPendingVerificationItemNoneTypeTfnPendingVerificationItem,
    null
  >({
    fetchIdsUrl: FETCH_IDS_URL,
    fetchPageDataUrl: FETCH_PAGE_DATA_URL,
    fetchIdsParams,
    initialRowsPerPage,
  });
};

export default useTfnVerificationsPagination;
